// extracted by mini-css-extract-plugin
module.exports = {"container":"content_blocks_image_text-module--container--2tkpv","text":"content_blocks_image_text-module--text--xs8Vh"};